import { createStore } from "vuex"
import axios from "axios"

export const store = createStore({
    state: {
        user: {
            firstName: "",
            lastName: "",
            email: ""
        },
        club: {
            name: process.env.VUE_APP_CLUB_NAME
        },
        loading: false,
        sidebar: true,
        insights: {
            selectedPlayers: {}
        },
        currentMediaDirectory: "/",
        mediaLibrary: {
            directoryName: "Root",
            directoryID: "root",
            subdirectories: [],
            activeTree: [],
            editImage: null,
            selectedImage: {
                imageKey: "",
                mediaLibraryID: ""
            },
            multiSelectedImages: []
        },
        news: [],
        newsPageCount: 0,
        newsPageSize: 20,
        newsPageNumber: 1,
        properties: [],
        selectedProperty: null,
        paymentMethod: null,
        primaryColor: null,
        secondaryColor: null
    },

    mutations: {
        toggleSidebar(state, val) {
            state.sidebar = val;
        },
        openSidebar(state) {
            state.sidebar = true
        },
        closeSidebar(state) {
            state.sidebar = false
        },
        startLoading(state) {
            state.loading = true
        },
        completeLoading(state) {
            state.loading = false
        },
        saveUserDetails(state, userDetails) {
            state.user.firstName = userDetails.firstName
            state.user.lastName = userDetails.lastName
            state.user.email = userDetails.email
        },
        saveCurrentMediaDirectory(state, val) {
            state.currentMediaDirectory = val
        },
        savePlayerInsights(state, selectedPlayers) {
            state.insights.selectedPlayers = selectedPlayers
        },
        storeDirectoryDetails(state, directory) {
            state.mediaLibrary.directoryName = directory.directoryName
            state.mediaLibrary.directoryID = directory.directoryID
        },
        storeActiveTree(state, activeTree) {
            state.mediaLibrary.activeTree = activeTree
        },
        editImage(state, mediaLibraryID) {
            state.mediaLibrary.editImage = mediaLibraryID
        },
        selectImage(state, selectedImage) {
            state.mediaLibrary.selectedImage.mediaLibraryID = selectedImage.mediaLibraryID
            state.mediaLibrary.selectedImage.imageKey = selectedImage.imageKey
        },
        removeImage(state) {
            state.mediaLibrary.selectedImage.mediaLibraryID = ""
            state.mediaLibrary.selectedImage.imageKey = ""
        },
        multiSelectImage(state, mediaLibraryID) {

            if (!state.mediaLibrary.multiSelectedImages.includes(mediaLibraryID)) {

                state.mediaLibrary.multiSelectedImages.push(mediaLibraryID)
            } else {

                const indexOfItem = state.mediaLibrary.multiSelectedImages.indexOf(mediaLibraryID)
                state.mediaLibrary.multiSelectedImages.splice(indexOfItem, 1)
            }
        },
        multiSelectImageClearAll(state) {
            state.mediaLibrary.multiSelectedImages = []
        },
        removeUserDetails(state) {
            state.user.firstName = ""
            state.user.lastName = ""
            state.user.email = ""
        },

        // Set all news
        setNews(state, news) {
            state.news = news
        },

        // Update a single news item by id
        updateNewsSingle(state, newsItem) {
            const index = state.news.findIndex(news => news.postID === newsItem.postID)

            if (index !== -1) {
                state.news.splice(index, 1, newsItem)
            }
        },

        // Remove a single news item
        removeNewsSingle(state, id) {
            const index = state.news.findIndex(news => news.postID === id)

            if (index !== -1) {
                state.news.splice(index, 1)
            }
        },

        addNewsSingle(state, newsItem) {
            state.news.unshift(newsItem)
        },

        setNewsPageNumber(state, pageNumber) {
            state.newsPageNumber = pageNumber
        },
        setSelectedProperty(state, propertyId) {
            state.selectedProperty = propertyId;
        }
    },

    getters: {
        propertiesExist: state => {
            return state.properties.length > 0
        },

        defaultProperty: state => {
            return state.properties[0]?.id
        }
    },

    actions: {
        fetchNews({ commit, state }, jwtSubscriber) {
            const newsSearchAPI = `${process.env.VUE_APP_NEWSAPI_V2}/search`
            const propertyID = state.selectedProperty;
            let query = "(NOT deleted:true)"
            state.loading = true
            if (propertyID) {
                query = `(propertyID:${propertyID} AND ${query})`;
            }
            const encodedQuery = encodeURIComponent(query);

            const url = `${newsSearchAPI}?q=${encodedQuery}&page.size=${state.newsPageSize}&page.number=${state.newsPageNumber}&sort=publishedDateTime:desc`
            jwtSubscriber.subscribe((jwt) => {

                axios({
                    method: "GET",
                    url: url,
                    headers: { "Authorization": jwt }
                })
                    .then(response => {
                        console.log("response: ", response);
                        state.newsPageCount = response.data.meta.totalPages;
                        commit("setNews", response.data.data.map(({ attributes }) => attributes))
                        state.loading = false;
                    })
                    .catch(e => {
                        console.error("Problem retrieving pages", e);
                        state.loading = false
                    });
            })
        },
        async fetchProperties({ state }, jwtSubscriber) {
            const propertiesAPI = `https://properties.cms.admin.gc.${process.env.VUE_APP_MAIN_DOMAIN}/v2`
            state.loading = true

            try {
                const jwt = await new Promise((resolve, reject) => {
                    jwtSubscriber.subscribe(resolve, reject)
                })

                const response = await axios.get(propertiesAPI, { "headers": { "Authorization": jwt } })
                state.properties = response.data.data
                state.loading = false

                return state.properties
            } catch (e) {
                console.error("Problem retrieving properties", e)
                state.loading = false

                return []
            }
        },

        async fetchConfig({ state }, jwtSubscriber) {
            const configAPI = `${process.env.VUE_APP_CONFIGAPI}/live`
            try {
                const jwt = await new Promise((resolve, reject) => {
                    jwtSubscriber.subscribe(resolve, reject)
                })

                const response = await axios.get(configAPI, { "headers": { "Authorization": jwt } })
                state.paymentMethod = response.data.data?.attributes?.club?.features?.paymentProvider
                state.primaryColor = response.data.data?.attributes?.style?.colors?.primary[500]
                state.secondaryColor = response.data.data?.attributes?.style?.colors?.secondary[500]
                state.loading = false
            } catch (e) {
                console.error("Problem retrieving config", e);
                state.loading = false
            }
        },

    }
})

